package eu.bontlab.components

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontStyle
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.toModifier
import eu.bontlab.models.Testimonial
import eu.bontlab.models.Theme
import eu.bontlab.styles.AboutTextStyle
import eu.bontlab.util.Constants.FONT_FAMILY
import org.jetbrains.compose.web.css.Color
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Composable
fun TestimonialCard(
    modifier: Modifier = Modifier,
    testimonial: Testimonial,
    breakpoint: Breakpoint
) {
    Link(
        modifier = modifier.maxWidth(500.px)
            .textDecorationLine(TextDecorationLine.None)
            .display(DisplayStyle.InlineBlock),
        path = testimonial.path
    ) {
        Row {
            Image(
                modifier = Modifier
                    .margin(right = 20.px)
                    .maxWidth(if (breakpoint >= Breakpoint.MD) 160.px else 80.px)
                    .borderRadius(
                        topLeft = 60.px,
                        topRight = 60.px,
                        bottomLeft = 60.px,
                        bottomRight = 0.px
                    ),
                src = testimonial.icon,
                alt = "Avatar Image"
            )
            Column {
                Row(
                    modifier = Modifier
                        .fillMaxWidth()
                        .margin(bottom = 10.px)
                ) {
                    Column(modifier = Modifier
                        .fillMaxWidth(
                            if (breakpoint >= Breakpoint.MD) 100.percent
                            else 90.percent
                        )
                        .fillMaxHeight(),
                        horizontalAlignment = Alignment.CenterHorizontally)
                    {
                        P(
                            attrs = Modifier
                                .fillMaxWidth()
                                .margin(topBottom = 0.px)
                                .fontFamily(FONT_FAMILY)
                                .fontSize(18.px)
                                .fontWeight(FontWeight.Bold)
                                .color(Theme.Primary.rgb)
                                .toAttrs()
                        ) {
                            Text(testimonial.fullName)
                        }
                        P(
                            attrs = Modifier
                                .fillMaxWidth()
                                .margin(topBottom = 0.px)
                                .fontFamily(FONT_FAMILY)
                                .fontSize(12.px)
                                .fontWeight(FontWeight.Normal)
                                .color(Theme.Secondary.rgb)
                                .toAttrs()
                        ) {
                            Text(testimonial.profession)
                        }
                        //   RatingBar(modifier = Modifier.margin(top = 5.px))
                        P(
                            attrs = AboutTextStyle.toModifier()
                                .margin(bottom = 0.px, right = 20.px)
                                .maxWidth(300.px)
                                .fontFamily(FONT_FAMILY)
                                .fontSize(14.px)
                                .fontWeight(FontWeight.Normal)
                                .fontStyle(FontStyle.Italic)
                                .color(Theme.LightGray.rgb)
                                .toAttrs()
                        ) {
                            Text(testimonial.review)
                        }
                    }
                }  /*
                P(
                    attrs = Modifier
                        .fillMaxWidth()
                        .margin(topBottom = 0.px)
                        .fontFamily(FONT_FAMILY)
                        .fontSize(12.px)
                        .fontWeight(FontWeight.Normal)
                        .color(Theme.Gray.rgb)
                        .toAttrs()
                ) {
                    Text(testimonial.review)
                } */

            }
        }
    }
}